export default {
	title: 'Výsledek vyhledávání PS',
	policyNo: 'Číslo PS/ RS/ Pořad. č.',
	insurer: 'Pojistník',
	insurance: 'Pojištění',
	policyNoState: 'Stav PS',
};
